import expenseRecord from '@/api/expense-record'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  expense_items: [],
  currencies: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  SET_EXPENSE_ITEMS(state, expense_items) {
    state.expense_items = expense_items
  },

  SET_CURRENCIES(state, currencies) {
    state.currencies = currencies
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return expenseRecord.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return expenseRecord.store(data)
  },

  async find(context, id) {
    return await expenseRecord.find(id)
  },

  update(context, data) {
    return expenseRecord.update(data)
  },

  destroy(context, id) {
    return expenseRecord.destroy(id)
  },

  async dataBeforeCreate({ commit, state }) {
    if (!state.expense_items.length > 0) {
      let response = await expenseRecord.getExpenseItem()
      commit('SET_EXPENSE_ITEMS', response)
    }
    if (!state.currencies.length > 0) {
      let response = await expenseRecord.getCurrency()
      commit('SET_CURRENCIES', response)
    }
  }
}
